module.exports = __webpack_public_path__ + "static/media/api_vector_graphic_2.60a96fa3.svg";